module.exports = __webpack_public_path__ + "assets/ProfileIcon.c1c8343e1dc79c400c8c82c7bac1acbc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/user-menu/ProfileIcon.svg
// module id = 190
// module chunks = 0